// @flow
import type {DataTables} from 'datatables.net';

export default function order(column: String, options: any,
    dtSettings: DataTables.Settings, component: JQuery) {
        let col = dtSettings.columns.find(c => c.title == column);
        let colIndex = dtSettings.columns.indexOf(col);
        dtSettings.order.push([colIndex, options]);
}